import QuoteRow from "./QuoteRow";

export default function QuoteTable({
  quotes,
  loading,
  onDownloadPdf,
  onDelete,
  onClearFilters,
  hasFilters,
}) {
  if (loading) {
    return (
      <div className="text-center mt-4">
        <div className="spinner"></div>
        <p className="mt-2">Cargando cotizaciones...</p>
      </div>
    );
  }

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>N° COTIZACIÓN</th>
            <th>CLIENTE</th>
            <th>FECHA</th>
            <th>ITEMS</th>
            <th>TOTAL</th>
            <th>PDF</th>
            <th>ACCIONES</th>
          </tr>
        </thead>

        <tbody>
          {quotes.length === 0 ? (
            <tr>
              <td colSpan={7} className="text-center">
                <div className="no-data">
                  <p>📭 No hay cotizaciones para mostrar</p>
                  {hasFilters && (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={onClearFilters}
                    >
                      Limpiar filtros
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ) : (
            quotes.map((quote) => (
              <QuoteRow
                key={quote.id}
                quote={quote}
                onDownloadPdf={onDownloadPdf}
                onDelete={onDelete}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}